"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import UserPageIdentityAddStatements from "./UserPageIdentityAddStatements";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function UserPageIdentityStatementsAddButton(t0) {
  const $ = _c(15);
  const {
    profile
  } = t0;
  const [isAddStatementsOpen, setIsAddStatementsOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isAddStatementsOpen) {
    t3 = () => setIsAddStatementsOpen(!isAddStatementsOpen);
    $[2] = isAddStatementsOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-h-5 tw-w-5 -tw-ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t5 = <span>Add</span>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3) {
    t6 = <PrimaryButton loading={false} disabled={false} onClicked={t3}>{t4}{t5}</PrimaryButton>;
    $[6] = t3;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isAddStatementsOpen || $[9] !== isMounted || $[10] !== profile) {
    t7 = isMounted && isAddStatementsOpen && <UserPageIdentityAddStatements profile={profile} onClose={() => setIsAddStatementsOpen(false)} />;
    $[8] = isAddStatementsOpen;
    $[9] = isMounted;
    $[10] = profile;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}